import React from 'react';
import PropTypes from 'prop-types';
import {
  Popup,
  Icon,
  Image,
  Divider,
  Checkbox,
  Table,
  Header,
  TextArea,
  Grid,
  Label,
  Form,
} from 'semantic-ui-react';

import DyzioModal from 'dyzio-shared-components/lib/components/dyzio-modal';
import _ from 'lodash';
import moment from 'moment';

import { transformHashtagstIntoArray } from '../../utils/hashtags-utils';

const SIMPLE_FORMAT = 'YYYY-MM-DD';

const inviteImageStyle = {
  margin: '0 auto',
  display: 'block',
};

const textAlignCenter = {
  textAlign: 'center',
};


class InviteModal extends React.Component {
  constructor() {
    super();

    this.state = {
      notes: null,
    };
  }

  onChange = (e, { name, value, checked }) => {
    this.setState({
      [name]: value || checked,
    });
  }


  onSendRequest = () => {
    const data = this.state;
    const {
      sendHandler,
    } = this.props;

    sendHandler({ data });
  }

  render() {
    const {
      email,
      thumbnail,
      closeHandler,
      sendHandler,
      inviteSentOK,
      name,
      campaignName,
      hashtags,
      campaignStart,
      campaignEnd,
      campaignType,
    } = this.props;

    const { notes, youtube, instagram, twitter, facebook } = this.state;


    const startDate = moment(campaignStart).format(SIMPLE_FORMAT);
    const endDate = moment(campaignEnd).format(SIMPLE_FORMAT);

    const hashtagArray = transformHashtagstIntoArray(hashtags);
    return (
      <DyzioModal
        headerText={`Authorisation Request - ${name}`}
        size="small"
        onClose={closeHandler}
        hasActionButton
        actionButtonIcon={<Icon name="send" />}
        actionButtonContent="Send authorisation request"
        onActionButtonClick={this.onSendRequest}
        shouldDisableActionButton={inviteSentOK}
      >
        <Form>
          <Grid columns={2}>
            <Grid.Row>
              <Grid.Column width={7}>

                <div style={textAlignCenter}>
                  <Image
                    src={thumbnail}
                    centered
                    className="ui small circular"
                    style={inviteImageStyle}
                  />
                  <Divider hidden />
                  <p>
                    <Label basic>
                      <Icon name="at" />&nbsp;
                      {email}&nbsp;
                      <Popup
                        trigger={<Icon size="large" color="green" name="edit" />}
                        content="close this window and edit the email on the influencer page if necessary"
                      />
                    </Label>
                  </p>
                  <Divider />
                  <p>What channels do you require?</p>
                  <Table>
                    <Table.Row>
                      <Table.Cell>
                        <Checkbox
                          name="instagram"
                          label="Instagram"
                          checked={instagram}
                          onChange={this.onChange}
                        />
                      </Table.Cell>
                      <Table.Cell>
                        <Checkbox
                          name="youtube"
                          label="YouTube"
                          checked={youtube}
                          onChange={this.onChange}
                        />
                      </Table.Cell>
                    </Table.Row>
                    <Table.Row>
                      <Table.Cell>
                        <Checkbox
                          name="facebook"
                          label="Facebook"
                          checked={facebook}
                          onChange={this.onChange}
                        />
                      </Table.Cell>
                      <Table.Cell>
                        <Popup
                          content="Sorry, we do not currently authorise Twitter data" trigger={
                            <Checkbox
                              disabled
                              name="twitter"
                              label="Twitter"
                              checked={twitter}
                              onChange={this.onChange}
                            />
                          }
                        />
                      </Table.Cell>
                    </Table.Row>
                  </Table>

                </div>

              </Grid.Column>
              <Grid.Column width={9}>

                <div style={textAlignCenter}>
                  <Table celled basic="very" style={{ padding: 0 }}>
                    <Table.Body>
                      <Table.Row>
                        <Table.Cell>
                          <Header as="h5" textAlign="center">
                            name
                          </Header>
                        </Table.Cell>
                        <Table.Cell>{campaignName}</Table.Cell>
                      </Table.Row>

                      <Table.Row>
                        <Table.Cell>
                          <Header as="h5" textAlign="center">
                        type
                          </Header>
                        </Table.Cell>
                        <Table.Cell>{campaignType}</Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell>
                          <Header as="h5" textAlign="center">
                        tags
                          </Header>
                        </Table.Cell>
                        <Table.Cell>{
                          _.map(hashtagArray, h => <Label basic content={h} />)
                        }</Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell>
                          <Header as="h5" textAlign="center">
                        dates
                          </Header>
                        </Table.Cell>
                        <Table.Cell>{startDate} to {endDate}</Table.Cell>
                      </Table.Row>
                    </Table.Body>
                  </Table>

                  <p>Notes for the influencer</p>
                  <TextArea
                    style={{ marginTop: 10 }}
                    placeholder="your notes will be added to the request email"
                    name="notes"
                    onChange={this.onChange}
                    value={notes}
                  />

                </div>

              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Form>

      </DyzioModal>
    );
  }
}

InviteModal.propTypes = {
  email: PropTypes.string.isRequired,
  thumbnail: PropTypes.string.isRequired,
  closeHandler: PropTypes.func.isRequired,
  sendHandler: PropTypes.func.isRequired,
  inviteSentOK: PropTypes.bool.isRequired,
};

export default InviteModal;



/** WEBPACK FOOTER **
 ** ./src/components/invite-modal2/index.js
 **/